module.exports = __webpack_public_path__ + "static/media/home.7f1ec630.jpg";